export function sampleBoolean(schema) {
  return true; // let be optimistic :)
}
